import styles from "./court.module.css"

const courtStyles = {
    container: "container relative",
    outerContainerForBuyToken: `relative bg-liveGameColor px-4 py-3 pt-9 ${styles.image_wrpr} mt-[70px]`,
    legendContainer: `pb-[20px] flex items-center gap-5 ${styles.legendContainer} absolute bg-liveGameColor px-4 py-3 p-[20px] left-0 top-[-60px] min-w-[500px] w-[500px]`,
    legendImageContainer: `w-full h-auto flex justify-center py-[8px] px-3 rounded-md bg-[#fff] ${styles.legendImageContainer}`,
    legendImage: `w-full h-full max-w-[48px] h-full object-fit`,
    legendTextContainer: `w-full flex flex-col flex-wrap justify-space-between`,
    textHeader: `text-white text-stroke ${styles.textHeader}`,
    subHeader: `font-medium ${styles.subHeader}`,
    highOrderWrapper: `relative h-auto ${styles.highOrderWrapper}
                    max-md:h-[350px]`,
    deployTokenPage: ` ${styles.deployTokenPage}`,
    ScorerTokenPage: `${styles.ScorerTokenPage}`,
    noteTextBelow: `absolute bottom-0 right-0 text-[12px] max-w-[150px] text-right ${styles.noteTextBelow}
                    md:text-[16px]
                    sm:max-w-full
    `,
    noteTextTop: `absolute top-3 right-0 text-[12px] max-w-[150px] text-right hidden ${styles.noteTextTop}
                    md:text-[16px]
                    sm:max-w-full
    `
}

const CourtWrapperStyles = {
    mainSVgContainer: `w-full relative h-full`,
}

const zoomStyles = {
    zoomContainer: `absolute z-[10] ${styles.zoomContainer}`,
    zoomContols: `flex flex-col gap-2 items-center `,
    buttonContainer: `flex flex-col`,
    zoomEdit: `color-[#000] bg-[#fff] text-[25px]  px-[10px] border-1 justify-center items-center cursor-pointer transition-all duration-200 ease-in-out text-[#000] cursor-pointer hover:bg-[#000] hover:text-[#fff] ${styles.zoomEdit}
               max-sm:text-[18px]
    `,
    zoomIn: `rounded-t-[50%]`,
    zoomOut: `rounded-b-[50%]`,
    resetButton: `w-[35px] h-[35px] bg-[#000] flex justify-center items-center rounded-full hover:bg-[#4a4a4c] hover:color-[#000]
                max-sm:w-[16px] max-sm:h-[16px]`
}

const minimapStyles = {
    minimapContainer: `absolute w-[200px] h-[120px] bg-themeColor bottom-0 left-0 border border-black overflow-hidden ${styles.minimapContainer}`,
    minimapViewport: `absolute border-2 border-[#ff6347] bg-[#ff63474d] transition-all duration-200 ease`
}

const TokenColorDetailsStyles = {
    outerContainer: `absolute right-2 bg-themeWhiteShadow p-2 z-10 min-w-[165px] top-0 ${styles.outerContainer}`,
    smallScreenContainer: `block 
                        lg:hidden 
                        max-sm:top-2`,
    largeScreenContainer: `hidden items-center ${styles.largeScreenContainer}
                        lg:flex `,
    button: `flex items-center gap-2 w-full justify-between`,
    detailsContainer: `flex flex-col gap-2 ${styles.detailsContainer}`,
    detail: `flex gap-1 items-center`,
    coloredContainer: `h-[10px] w-[10px]`,
    detailText: `text-[12px]
                 sm:text-[14px]
    `,


}
export { courtStyles, CourtWrapperStyles, zoomStyles, minimapStyles, TokenColorDetailsStyles }